import { DynamicLayout } from "./layout";
import { PimoStaticReactLayout } from "./layout/static-layout";

/**
 * A simple layout that renders all elements by appending them to a DIV
 */
export class DefaultLayout<LayoutProps> extends DynamicLayout<
  undefined,
  undefined,
  undefined,
  LayoutProps
> {
  getLayoutComponent(): PimoStaticReactLayout<LayoutProps> {
    return ({ components }) => {
      return (
        <div>
          {components.map((c, i) => {
            const RenderedComponent = c.render();
            return <RenderedComponent key={i} />;
          })}
        </div>
      );
    };
  }
}
